<template>
  <div class="row" id="users">
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :apiURL="apiURL"
        :readonly="true"
        title="Bitácora"
        :queryParams="queryParams"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  data: () => ({
    headers: [
      {
        text: 'Usuario',
        value: 'name',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Rol',
        value: 'description',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acción',
        value: 'accion',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Dirección IP',
        value: 'ip_address',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Creación',
        value: 'created_at',
        align: 'left',
        sortable: true,
      },
    ],
    items: [],
    totalItems: 0,
    typePortal: 'D',
    apiURL: 'api/binnacle',
  }),
  computed: {
    queryParams() {
      return `&typePortal=${this.typePortal}`;
    },
  },
  components: {
    VuetifyTable,
  },
  methods: {},
};
</script>
